module.exports = __webpack_public_path__ + "static/media/graph-zoom-out.4129a354.svg";